import styled from 'styled-components';
import { device } from '../../../styles/devices';
import { SwiperStyles } from './Swiper.style';

export const LeftChevronWrap = styled.div`
  top: auto !important;
  bottom: 50px !important;
  left: -100px !important;
  position: absolute !important;
  &:after {
    content: none !important;
  }
`;

export const RightChevronWrap = styled.div`
  top: auto !important;
  bottom: 50px !important;
  right: -100px !important;
  position: absolute !important;
  &:after {
    content: none !important;
  }
`;

export const SwiperContainer = styled(SwiperStyles)<{ isUsed: boolean }>`
  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
  }
  .swiper-container {
    width: 100%;
    height: 300px;
    margin-left: auto;
    margin-right: auto;
  }
  .mySwiper {
    height: 20%;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .mySwiper .swiper-slide {
    @media ${device.tablet} {
      ${({ isUsed }) => (isUsed ? 'height: 75px' : '')};
    }
    @media (min-width: 900px) {
      ${({ isUsed }) => (isUsed ? 'height: 90px' : '')};
    }
    @media ${device.laptop} {
      ${({ isUsed }) => (isUsed ? 'height: 100px' : '')};
    }
    @media ${device.laptopM} {
      ${({ isUsed }) => (isUsed ? 'height: 125px' : '')};
    }
  }
  .mySwiper .swiper-slide-thumb-active {
    border: 3px solid black;
  }
  .mySwiper .swiper-slide-thumb-active img:hover {
    border: 3px solid transparent !important;
  }
  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 3px solid transparent;
  }
  .swiper-container-thumbs .swiper-wrapper .swiper-slide img {
    border: 3px solid transparent;
  }
  .swiper-container-thumbs .swiper-wrapper .swiper-slide img:hover {
    border: 3px solid black;
  }
  .swiper-button-disabled {
    display: none !important;
  }
  .mySwiper2 {
    height: 75%;
    width: 100%;
    .swiper-slide {
      @media ${device.tablet} {
        ${({ isUsed }) => (isUsed ? 'height: 300px' : '')};
      }
      @media (min-width: 900px) {
        ${({ isUsed }) => (isUsed ? 'height: 350px' : '')};
      }
      @media ${device.laptop} {
        ${({ isUsed }) => (isUsed ? 'height: 450px' : '')};
      }
      @media ${device.laptopM} {
        ${({ isUsed }) => (isUsed ? 'height: 650px' : '')};
      }
    }
  }
`;
